import { createFileRoute, Link } from "@tanstack/react-router";
import { Mic } from "lucide-react";
import { PageHeader } from "@/client/components/page-header";
import { buttonVariants } from "@/client/components/ui/button";
import { apiQuery, useApiSuspenseQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import { CirurgiasClient } from "@/client/modules/cirurgias/cirurgias-client";
import Loading from "@/client/modules/cirurgias/loading";

export const Route = createFileRoute("/app/cirurgias/")({
  loader: ({ context }) => ensurePage(context.queryClient, apiQuery("cirurgias", "page", {})),
  head: () => pageHead("Cirurgias"),
  pendingComponent: Loading,
  component: CirurgiasPage,
});

function CirurgiasPage() {
  const { data } = useApiSuspenseQuery("cirurgias", "page", {});
  return (
    <div className="mx-auto flex max-w-7xl flex-col gap-6">
      <PageHeader
        title="Cirurgias"
        description="Fila de cirurgias, agendamentos e relatórios."
        action={
          data.canDitar ? (
            <Link
              to="/app/cirurgias/ditado"
              search={{ cirurgia: undefined }}
              className={buttonVariants({ variant: "secondary", size: "sm" })}
            >
              <Mic className="h-4 w-4" /> Ditar descrição
            </Link>
          ) : undefined
        }
      />
      <CirurgiasClient
        cirurgias={data.cirurgias}
        precos={data.precos}
        isAdmin={data.isAdmin}
        userDisplayName={data.userDisplayName}
        showDoctorBadges={data.showDoctorBadges}
        canDitar={data.canDitar}
      />
    </div>
  );
}
